import React from 'react';
// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => (
  <svg {...props} width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.99466 9.375C4.82028 9.375 4.64591 9.28772 4.55872 9.20044L1.07117 5.70917C0.809609 5.44732 0.809609 5.01091 1.07117 4.74906C1.33274 4.48722 1.76868 4.48722 2.03025 4.74906L4.99466 7.71665L11.9698 0.821384C12.2313 0.559539 12.6673 0.559539 12.9288 0.821384C13.1904 1.08323 13.1904 1.51964 12.9288 1.78148L5.51779 9.20044C5.34342 9.28772 5.25623 9.375 4.99466 9.375Z" fill="currentcolor" />
  </svg>
);
